// function to update the pickup dates based on a string of \n sperated times
function updatePickupTimes(timesString) {
    // generate time options
    let timeOptions = `<option disabled selected value="">Select a Time</option>`;
    timesString.split("\n").forEach(time => {
        timeOptions += `<option value="${time}">${time}</option>`;
    });

    // update the time dropdown
    document.querySelector(`.cartPickupFormLabelInput[name="time"]`).innerHTML = timeOptions;
}

// setup cart settings from global variable
async function setupCart() {
    // fetch supplemental cart data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // variable to determine if there are any pickup items in the cart
    let hasPickup = false;

    // variable to determine the minimum lead time for pickup items
    let largestLeadTime = 0;

    // days of the week that are eligible for pickup, from the cart section's pickup days checkboxes
    const daysOfWeekEligibleForPickup = {
        "Monday": cartSettings.pickup_monday,
        "Tuesday": cartSettings.pickup_tuesday,
        "Wednesday": cartSettings.pickup_wednesday,
        "Thursday": cartSettings.pickup_thursday,
        "Friday": cartSettings.pickup_friday,
        "Saturday": cartSettings.pickup_saturday,
        "Sunday": cartSettings.pickup_sunday
    };

    // variable to determine if there is a holiday block in cart
    // this limits pickup days for certain collections
    // during passover, only allow pickups on 3-4 specific days
    let hasHolidayBlockInCart = false;

    // variable to determine if there is a category block in the cart
    // a category block is a category that is not eligible for pickup on certain dates
    // this might happen when they want to limit cake orders for certain days
    let hasCategoryBlockInCart = false;

    // loop through cart items to check for pickup items
    for (const key in cartData) {
        const item = cartData[key];

        // determine if the item is a pickup item
        if (item.options && item.options.nationwide === false) {
            hasPickup = true;

            // if the item has a lead time, check if it is larger than the current largest lead time
            if (item.options.order_time && item.options.order_time > largestLeadTime) {
                largestLeadTime = item.options.order_time;
            }

            // some items, like the Challah, have a pick_up_days, meaning ONLY those days are eligible for pickup.
            // since our logic is to determine the days that AREN'T eligible for pickup, we need to find the days that are not Eligible
            if (item.options.pick_up_days) {
                // loop through the days of the week and set the eligible days to false if they are not in the item's pick_up_days
                for (const day in daysOfWeekEligibleForPickup) {
                    if (!item.options.pick_up_days.includes(day)) {
                        daysOfWeekEligibleForPickup[day] = false;
                    }
                }
            }

            // if the item has a holiday block, we need to check if it is in the cart
            if (cartSettings.holiday_collection) {
                // gather all collections of item and compare to holiday check
                let collections = [];
                item.collections.forEach(collection => collections.push(collection.name.toLowerCase()));
                if (collections.includes(cartSettings.holiday_collection.toLowerCase())) {
                    hasHolidayBlockInCart = true;
                }
            }

            // if the item has a category block, we need to check if it is in the cart
            if (cartSettings.block_category_name && cartSettings.block_category_name.toLowerCase().includes(item.category.toLowerCase())) {
                hasCategoryBlockInCart = true;
            }
        }
    }

    // if there is a pickup item
    if (hasPickup) {
        // show the pickup date and time fields
        document.querySelector("#cartPickup").classList.add("active");

        // create an options object for flatpickr, allowing us to add either enable or disable to options as they contradict
        const pickerOptions = {
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d",
            minDate: new Date().fp_incr(largestLeadTime), // set the minimum date to today + the largest lead time
            disableMobile: true, // we don't want the native date picker on mobile
        }

        // if holiday pickup in cart, limit days for pickup entirely & bypass disable
        if (hasHolidayBlockInCart) {
            // function to only enable dates in cartSettings.holiday_pickup_only_dates
            pickerOptions.enable = [
                function (date) {
                    // get the date in YYYY-MM-DD
                    const currentDate = date.toISOString().split("T")[0];
                    // check if the date is in the cartSettings.holiday_pickup_only_dates
                    if (cartSettings.holiday_pickup_only_dates && cartSettings.holiday_pickup_only_dates.includes(currentDate)) {
                        return true; // enable this date
                    }
                }
            ]
        } else {
            // disable dates that are not eligible for pickup
            pickerOptions.disable = [
                function (date) {
                    // get the date in YYYY-MM-DD
                    const currentDate = date.toISOString().split("T")[0];

                    // determine if the date is a day that is not eligible for pickup (Monday, for example)
                    const dayName = date.toLocaleString("en-US", {weekday: "long"});

                    // if the day is not eligible for pickup
                    if (!daysOfWeekEligibleForPickup[dayName]) {
                        return true; // disable this date
                    }

                    // check if the date is in the cartSettings.block_general_dates
                    if (cartSettings.block_general_dates && cartSettings.block_general_dates.includes(currentDate)) {
                        return true; // disable this date
                    }

                    // check if the date is in the cartSettings.block_category_dates
                    if (hasCategoryBlockInCart && cartSettings.block_category_dates && cartSettings.block_category_dates.includes(currentDate)) {
                        return true; // disable this date
                    }

                    // otherwise, the date is eligible for pickup
                    return false; // do not disable this date
                }
            ]
        }

        // initialize date picker
        flatpickr(`.cartPickupFormLabelInput[name="date"]`, pickerOptions);

        // on date change, re-validate the time options
        document.querySelector(`.cartPickupFormLabelInput[name="date"]`).addEventListener("change", function () {
            // get the selected pickup date
            const pickupDate = document.querySelector(`.cartPickupFormLabelInput[name="date"]`).value;

            // check if the pickup date is in the cartModifiedPickupTimes object
            if (cartModifiedPickupTimes[pickupDate]) {
                updatePickupTimes(cartModifiedPickupTimes[pickupDate]);
                return;
            }

            // otherwise, use the default pickup times from cart settings
            updatePickupTimes(cartSettings.pickup_times);
        });
    }

    // checking terms should enable the checkout button
    document.querySelector("#cartTermsInput")?.addEventListener("change", function () {
        document.querySelector("#cartCheckout").disabled = this.checked === false
    });

    // checkout button click
    document.querySelector("#cartCheckout")?.addEventListener("click", async function () {
        // determine if any items are over the max quantity
        for (const key in cartData) {
            const item = cartData[key];
            if (item.options && item.options.limit && item.quantity > item.options.limit) {
                alert(`The maximum quantity for ${item.product_title} is ${item.options.limit}. Please reduce the quantity and try again.`);
                return;
            }
        }

        // pickup orders needs a date
        if (hasPickup) {
            // get the pickup time, date and cart
            const pickupDate = document.querySelector(`.cartPickupFormLabelInput[name="date"]`).value;
            const pickupTime = document.querySelector(`.cartPickupFormLabelInput[name="time"]`).value;

            // validate pickup date and time
            if (pickupDate === "") {
                alert("Select a Pick-Up Date Please!")
                return;
            }

            // if no time is selected
            if (pickupTime === "") {
                alert("Select a Pick-Up Time Please!")
                return;
            }

            // validate cart notes are set
            if (pickupDate.length === 1 || pickupTime === "") {
                alert("Select a Pick-Up Date & Time Please!")
                return;
            }

            // start loading button
            this.classList.add("loading");

            // add to line item properties
            for (const item of cart.items) {
                // update properties to include pickup date and time
                const properties = item.properties || {};
                properties["Pickup"] = `${pickupDate} @ ${pickupTime}`;

                // update to shopify
                cart = await changeCart({
                    id: item.key,
                    properties: properties,
                    quantity: item.quantity
                });
            }
        }

        // start loading button
        this.classList.add("loading");

        // update cart note
        cart = await updateCart({
            note: document.querySelector("#cartNoteInput").value,
        });

        // redirect to checkout page
        window.location.href = "/checkout"

        // stop loading button
        this.classList.remove("loading");
    });
}

setupCart();

